export default __webpack_public_path__ + "static/cruiselogo_scenic-446d0d23198e27716740fdeeeaf8ccc3.png";